<template>
   <div class="about-third-section" v-if="about != null">
        <div class="third-promo">
            <div class="promo-pic" :style="'background-image: url(' + about.about_third_gallery[0] + ')'">
            </div>
            <div class="promo-set"></div>
            <div class="container">
                <div class="promo-content">
                    <h4>{{about.about_third_section}}</h4>
                    <div class="promo-title">
                        <h2>{{about.about_third_title}}</h2>
                    </div>
                    <div class="promo-title-gold">
                        <h3>{{about.about_third_title_main}}</h3>
                    </div>
                    <div class="promo-pic-mobile" :style="'background-image: url(' + about.about_third_gallery[0] + ')'">
                    </div>
                    <div class="promo-desc" v-html="about.about_third_desc"></div>
                    <a href="#" class="link-share">Поделиться MONACO RESIDENCE</a>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
    import share from '@/components/share/share.vue'
    import tileImages from '@/components/tile-images/tile-images.vue'
    export default {
        name: 'about-third-second',
        components: {
            tileImages,
            share,
        },
        data () {
            return {
            }
        },
        methods: { 
        },
        computed: {
            about() {
                return this.$store.state.about
            }
        },
        created () {
        },
        mounted () {
            // this.initPinchZoomer();
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about-elems/about-elem-third.scss';
    // @import '@/styles/components/about/about-respond/about-elem-third-respond.scss';
</style>